// extracted by css-extract-rspack-plugin
export default {"root":"S_32zR","indicators":"P7cgeh"};